const dirtyTrackerStore = {
  namespaced: true,
  state: {
    dirtyComponents: []
  },
  mutations: {
    DIRTY (state, key) {
      const newDirtyComponents = state.dirtyComponents.filter(item => item !== key);
      newDirtyComponents.push(key);
      state.dirtyComponents = newDirtyComponents;
    },
    UNDIRTY (state, key) {
      state.dirtyComponents = state.dirtyComponents.filter(item => item !== key);
    },
    UNDIRTY_ALL (state) {
      state.dirtyComponents = [];
    }
  },
  getters: {
    isDirty (state) {
      return state.dirtyComponents.length > 0;
    }
  }
};

export default dirtyTrackerStore;
